document.addEventListener('DOMContentLoaded', function() {
    // Agrega un escucha de clic al cuerpo del documento
    document.body.addEventListener('click', function(event) {
        // Verifica si el clic se realizó en el botón específico
        if (event.target.matches('.qsc2-basic.qsc2-btn.qsc2-checkout-button')) {
            // Redirige al usuario a la URL deseada
            window.location.href = '/checkout/';
        }
    });
});

function changeContent(contentId, button) {
  // Define los contenidos asociados a cada botón
  const contents = {
    1: {
      title: "Contenido 1",
      text: "Este es el contenido asociado al botón 1.",
    },
    2: {
      title: "Contenido 2",
      text: "Este es el contenido asociado al botón 2.",
    },
    3: {
      title: "Contenido 3",
      text: "Este es el contenido asociado al botón 3.",
    },
    4: {
      title: "Contenido 4",
      text: "Este es el contenido asociado al botón 4.",
    },
  };

  // Actualiza el contenido dinámico
  const contentBox = document.getElementById("content");
  contentBox.innerHTML = `
    <h4>${contents[contentId].title}</h4>
    <p>${contents[contentId].text}</p>
  `;

  // Cambiar la clase activa del botón
  const buttons = document.querySelectorAll(".btn-infososte");
  buttons.forEach((btn) => btn.classList.remove("btn-infososteactive"));
  button.classList.add("btn-infososteactive");
}